export const CDN = "https://cdn.checkout.com/js/framesv2.min.js";
export const CARD_NUMBER_FRAME = "card-number-frame";
export const EXPIRY_DATE_FRAME = "expiry-date-frame";
export const CVV_FRAME = "cvv-frame";
export const CARD_FRAME = "card-frame";
export const SCHEME_CHOICE_FRAME = "scheme-choice-frame";
